import { AuditAction, AuditLogQueryParams, AuditResourceType } from '_lib/api';
import { useCallback } from 'react';
import { useDispatch, useStore } from 'react-redux';

import { AppDispatch, RootState } from '..';
import auditReducer from './auditReducers';
import { AuditFilters } from './auditTypes';
import { auditFiltersSelector } from './selectors';

const toDate = (iso: string | null): Date | undefined => {
  if (!iso) {
    return undefined;
  }
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? undefined : date;
};

export const filtersToQueryParams = (
  filters: AuditFilters,
  page: number,
  limit: number,
): AuditLogQueryParams => ({
  page,
  limit,
  action: (filters.action || undefined) as AuditAction | undefined,
  resourceType: (filters.resourceType || undefined) as AuditResourceType | undefined,
  username: filters.username.trim() || undefined,
  resourceId: filters.resourceId.trim() || undefined,
  fromDate: toDate(filters.fromDate),
  toDate: toDate(filters.toDate),
});

// Mirrors useDenmsRequest: reads the current filters straight off the store so callers only
// have to pass the pagination they own.
export const useAuditLogsRequest = ({
  currentPage,
  itemsPerPage,
}: {
  currentPage: number;
  itemsPerPage: number;
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const store = useStore<RootState>();

  return useCallback(() => {
    const filters = auditFiltersSelector(store.getState());
    dispatch(
      auditReducer.actions.auditLogsRequest(
        filtersToQueryParams(filters, currentPage, itemsPerPage),
      ),
    );
  }, [dispatch, store, currentPage, itemsPerPage]);
};

export default useAuditLogsRequest;
